export default __webpack_public_path__ + "static/media/Logo - Branca.d6f125d0.png";